import React from "react";
import PropTypes from "prop-types";
import styles from "./ProfileCard.module.css";

function ProfileCard({
  name,
  designation,
  semester,
  austDepartment,
  cdcDepartment,
  email,
  primaryPhone,
  secondaryPhone,
  facebook,
  instagram,
  linkedin,
  portfolio,
  image,
}) {
  return (
    <div className={styles.profileCard}>
      <div className={styles.imageWrapper}>
        <img src={image} alt={name} className={styles.profileImage} />
      </div>
      <h2 className={styles.profileName}>{name}</h2>
      <p className={styles.profileDesignation}>{designation} - {cdcDepartment}</p>
      <p className={styles.profileDetails}>
        Semester: {semester} | Department: {austDepartment} 
      </p>
      <p>
        <b>Email:</b> <a href={`mailto:${email}`}>{email}</a>
      </p>
      <p> <b>Primary Phone:</b> 
        {" "}
        <a href={`tel:${primaryPhone}`} target="_blank" rel="noopener noreferrer">
          {primaryPhone}
        </a>
      </p>
      <p><b>Secondary Phone:</b>
        {" "}
        <a href={`tel:${secondaryPhone}`} target="_blank" rel="noopener noreferrer">
          {secondaryPhone}
        </a>
      </p>
      <div className={styles.socialLinks}>
        {facebook && (
          <a
            href={facebook}
            className={`${styles.socialButton} ${styles.facebook}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
        )}
        {instagram && (
          <a
            href={instagram}
            className={`${styles.socialButton} ${styles.instagram}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
        )}
        {linkedin && (
          <a
            href={linkedin}
            className={`${styles.socialButton} ${styles.linkedin}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
        )}
        {portfolio && (
          <a
            href={portfolio}
            className={`${styles.socialButton} ${styles.portfolio}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Portfolio
          </a>
        )}
      </div>
    </div>
  );
}

ProfileCard.propTypes = {
  name: PropTypes.string.isRequired,
  designation: PropTypes.string.isRequired,
  semester: PropTypes.string,
  austDepartment: PropTypes.string,
  cdcDepartment: PropTypes.string,
  email: PropTypes.string,
  primaryPhone: PropTypes.string,
  secondaryPhone: PropTypes.string,
  facebook: PropTypes.string,
  instagram: PropTypes.string,
  linkedin: PropTypes.string,
  portfolio: PropTypes.string,
  image: PropTypes.string.isRequired,
};

export default ProfileCard;
